import type { Dispatch } from 'react';
import type { UseFormReturn } from 'react-hook-form';
import type { GIFT_MESSAGE_FIELD, Shipment } from '../../../bff-api/baskets/model';

export interface AppliedGiftOption {
    giftMessageString: string;
    giftMessageLines: string[];
    giftSenderName: string;
}

export interface GiftOptionProps {
    appliedGiftOption: AppliedGiftOption;
    setAppliedGiftOption: Dispatch<AppliedGiftOption>;
}

export interface GiftOptionFormValues {
    giftSenderName: string;
    giftMessageText: string;
}

export interface GiftOptionAppliedProps {
    onDelete: () => void;
    onEdit: () => void;
    appliedGiftOption: AppliedGiftOption;
}

export interface GiftOptionTriggerProps {
    appliedGiftOption: AppliedGiftOption;
    isOpen: boolean;
    onOpen: () => void;
    removeGiftOption: () => void;
}

export interface GiftOptionDrawerProps {
    isOpen: boolean;
    onClose: () => void;
    applyGiftOption: (data: GiftOptionFormValues) => void;
    giftOptionsForm: UseFormReturn<GiftOptionFormValues>;
}

export const CHAR_LIMIT_SENDER_NAME = 36;

export const CHAR_LIMIT_PER_LINE = 40;

export const MAX_LINES = 4;

export const EMPTY_APPLIED_GIFT_OPTION: AppliedGiftOption = {
    giftMessageString: '',
    giftSenderName: '',
    giftMessageLines: [],
};

export const EMPTY_GIFT_MESSAGE_LINES = {
    giftMessage1: '',
    giftMessage2: '',
    giftMessage3: '',
    giftMessage4: '',
};

const GIFT_MESSAGE_FIELDS: GIFT_MESSAGE_FIELD[] = [
    'c_giftMessage1',
    'c_giftMessage2',
    'c_giftMessage3',
    'c_giftMessage4',
];

export const isSameGiftMessages = (
    m1: Pick<Shipment, GIFT_MESSAGE_FIELD>,
    m2: Pick<Shipment, GIFT_MESSAGE_FIELD>,
): boolean =>
    GIFT_MESSAGE_FIELDS.every((field) => (!m1[field] && !m2[field]) || m1[field] === m2[field]);
